export class DefaultCompletionOptions {

    static CreateChildResolution = "793bbafa-7f62-4af8-a156-515887d4d066";
    static Delegate = "b997a7f2-ad57-036f-8798-298c14309f46";
    static Complete = "5b108223-92db-49b9-8085-336758ccabaa";

  }